import { useState } from 'react';
import { DeviceType } from 'shared/models/device-type';

import LinkableDevice from 'features/device/linkable-device/domain/models/linkable-device';

export interface IDeviceLinkContextProviderHooks {
  organisationUnitId: string;
  devicesToHide: LinkableDevice[];
  selectedDevices: LinkableDevice[];
  transmitterResidentSettings?: DeviceType[];
  handleSelectedDevicesChanged: (devices: LinkableDevice[]) => void;
}

interface IProps {
  organisationUnitId: string;
  devicesToHide: LinkableDevice[];
  transmitterResidentSettings?: DeviceType[];
}

export const useDeviceLinkContextProviderHooks = (props: IProps): IDeviceLinkContextProviderHooks => {
  const { organisationUnitId, devicesToHide, transmitterResidentSettings } = props;
  const [selectedDevices, setSelectedDevices] = useState<LinkableDevice[]>([]);

  const handleSelectedDevicesChanged = (devices: LinkableDevice[]): void => {
    setSelectedDevices(devices);
  };

  return {
    organisationUnitId,
    devicesToHide,
    selectedDevices,
    transmitterResidentSettings,
    handleSelectedDevicesChanged,
  };
};
